import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { countryIs, field, REQUIRED } from "./utils";
import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";
import * as NETHERLANDS from "pages/employer-of-record/onboarding/profile-info/form/nl/constants.nl";

export const netherlandsFields = {
  nlThirtyPercentRulingEligible: field({
    type: FieldTypes.boolean,
    informationType: "identification",
    name: "nlThirtyPercentRulingEligible",
    label: "Are you eligible for the 30% ruling?",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("NL"),
    },
    hideWhen: {
      nationality: (value) => typeof value === "string" && value === "NL",
    },
    value: () => false,
  }),

  nlWorkPermitType: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "nlWorkPermitType",
    label: "Type of Work Permit",
    placeholder: "Select Work Permit Type",
    options: NETHERLANDS.WORK_PERMIT_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("NL"),
    },
    hideWhen: {
      nationality: (value) => typeof value === "string" && value === "NL",
    },
    value: () => "",
  }),

  nlWorkPermitStartDate: field({
    type: FieldTypes.date,
    informationType: "identification",
    name: "nlWorkPermitStartDate",
    label: "Work Permit Start Date",
    validations: {
      ...REQUIRED,
      date: {
        fn: {
          value: (value, context) => {
            const expirationDate = context.parent.nlWorkPermitExpirationDate;
            if (!expirationDate || !value) return true;
            return new Date(value) <= new Date(expirationDate);
          },
          message: "Start date cannot be after expiration date",
        },
      },
    },
    scenarios: {
      onboarding: countryIs("NL"),
    },
    hideWhen: {
      nationality: (value) => typeof value === "string" && value === "NL",
    },
    value: () => "",
    serialize: (value) => (value === "" ? null : value),
  }),

  nlWorkPermitExpirationDate: field({
    type: FieldTypes.date,
    informationType: "identification",
    name: "nlWorkPermitExpirationDate",
    label: "Work Permit Expiration Date",
    validations: {
      ...REQUIRED,
      date: {
        fn: {
          value: (value, context) => {
            const startDate = context.parent.nlWorkPermitStartDate;
            if (!startDate || !value) return true;
            return new Date(value) >= new Date(startDate);
          },
          message: "Expiration date cannot be before start date",
        },
      },
    },
    scenarios: {
      onboarding: countryIs("NL"),
    },
    hideWhen: {
      nationality: (value) => typeof value === "string" && value === "NL",
    },
    value: () => "",
    serialize: (value) => (value === "" ? null : value),
  }),

  nlWajongBenefitsEligible: field({
    type: FieldTypes.boolean,
    informationType: "identification",
    name: "nlWajongBenefitsEligible",
    label: "Are you eligible for Wajong benefits?",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("NL"),
    },
    value: () => false, // TODO: IEORN-3827 personalInfo("nlWajongBenefitsEligible", false),
    format: (value) => (value.toString() === "true" ? "Yes" : "No"),
  }),

  nlArbeidsgehandicapte: field({
    type: FieldTypes.boolean,
    informationType: "identification",
    name: "nlArbeidsgehandicapte",
    label:
      "Do you have a disability for which you may require reasonable accommodations (Arbeidsgehandicapte)?",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("NL"),
    },
    value: () => false, // TODO: IEORN-3827 personalInfo("nlArbeidsgehandicapte", false),
    format: (value) => (value.toString() === "true" ? "Yes" : "No"),
  }),
  nlBsn: taxIdFieldConfig("NL", "nlBsn"),
  nlConfirmBsn: confirmTaxIdFieldConfig("NL", "nlBsn"),
};
